"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _wrapSetConfig = _interopRequireDefault(require("./wrapSetConfig"));

var _wrapGet = _interopRequireDefault(require("./wrapGet"));

var _wrapMapResultToProps = _interopRequireDefault(require("./wrapMapResultToProps"));

var _wrapSet = _interopRequireDefault(require("./wrapSet"));

var _wrapLoad = _interopRequireDefault(require("./wrapLoad"));

var _wrapConnect = _interopRequireDefault(require("./wrapConnect"));

var _wrapReducer = _interopRequireDefault(require("./wrapReducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var compose = function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  }, function (arg) {
    return arg;
  });
};

var _default = compose(_wrapReducer.default, _wrapConnect.default, _wrapLoad.default, _wrapSet.default, _wrapMapResultToProps.default, _wrapGet.default, _wrapSetConfig.default)();

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/region-core/lib/region/index.js
// module id = 341
// module chunks = 0